import React from 'react';
import { t } from 'i18next';
import CustomMiniCard from '../../../../components/CustomMiniCard';
import NotInformation from '../../../../components/NotInformation';
import { getDateFormat, userDataTransformVisitor } from '../../../../Apis/functions';
import RowCardText from '../../../../components/RowCardText';
import CustomImageTable from '../../../../components/CustomImageTable';
import checkIcon from '../../../../assets/icon/checkIcon.svg';
import cancelIcon from '../../../../assets/icon/cancelIcon.svg';
import minusIcon from '../../../../assets/icon/ic-minus.svg';

const UserInvitations = ({ list }) => {

    return (<>
        {list?.length > 0 ?
            <>
                {list?.map((invitation) => {
                    return (
                        <CustomMiniCard>
                            <div className='px-0 d-flex justify-content-end'>
                                <RowCardText title={''} value={getDateFormat(invitation.startDate, true)} />
                            </div>

                            <div className='row'>
                                <div className='col-6 px-0'>
                                    <RowCardText title={t('name')} value={userDataTransformVisitor([invitation])[0].label} />
                                    <RowCardText title={t('telephone')} value={invitation?.visitorPhoneNumber} />
                                </div>
                                <div className='col-6 px-0 d-flex justify-content-end gap-4 mt-2'>
                                    <CustomImageTable
                                        image={invitation?.statusId === 38 ? checkIcon : invitation?.statusId === 39 ? cancelIcon : minusIcon}
                                        classNameImage={'object-fit-contain'}
                                    />
                                </div>
                            </div>
                        </CustomMiniCard>
                    );
                })}
            </>
            :
            <NotInformation text={t('no_information')} card={true} />
        }
    </>);
}

export default UserInvitations;
